<template>
  <div class="uyh-send-a-message" id="send-message">

    <!-- Text templates -->
    <div v-if="resource === 'text'" class="editor-wrapper">
      <TextDesign @reset="resetMantra"
                  @screenshot="screenShot"
                  @loader-active="$emit('loader-active')"
                  @loader-inactive="$emit('loader-inactive')"
                  :resetStatus="resetDisabled"
                  @enable-reset="enableReset"/>
      <TextEditorTools  @reset="resetMantra"
                        @screenshot="screenShot"
                        @loader-active="$emit('loader-active')"
                        @loader-inactive="$emit('loader-inactive')"
                        :resetStatus="resetDisabled"
                        @enable-reset="enableReset"/>
    </div>

    <!-- Image templates -->
    <div v-else-if="resource === 'image'" class="editor-wrapper">
      <ImageDesign @reset="resetMantra"
                   @screenshot="screenShot"
                   @loader-active="$emit('loader-active')"
                   @loader-inactive="$emit('loader-inactive')"
                   @scale-change="handleScale"
                   @horizontal-move="horizontalMove"
                   @vertical-move="verticalMove"
                   :resetStatus="resetDisabled"/>
      <ImageEditorTools @reset="resetMantra"
                        @screenshot="screenShot"
                        @loader-active="$emit('loader-active')"
                        @loader-inactive="$emit('loader-inactive')"
                        @scale-change="handleScale"
                        @horizontal-move="horizontalMove"
                        @vertical-move="verticalMove"
                        :resetStatus="resetDisabled"
                        @enable-reset="enableReset"/>
    </div>

  </div>
</template>

<script>
  import axios from 'axios'
  import TextDesign from '@/components/Text_Design.vue'
  import TextEditorTools from '@/components/Text_EditorTools.vue'
  import ImageDesign from '@/components/Image_Design.vue'
  import ImageEditorTools from '@/components/Image_EditorTools.vue'
  import TextMantraData from './../assets/text_mantras.json';
  import ImageMantraData from './../assets/image_mantras.json';
  import getCookie from '@/assets/javascripts/get_cookie'

  export default {
    name: 'send_message',
    data: function() {
      return {
        resource: '',
        canvas: '',
        aspect: 0,
        ratio: 0,
        base: 0,
        left: 0,
        top: 0,
        windowWidth: 0,
        topOffset: 0,
        leftOffset: 0,
        canvasHeight: 0,
        canvasWidth: 0,
        imageHeight: 0,
        imageWidth: 0,
        resetDisabled: true
      }
    },
    components: {
      TextDesign,
      TextEditorTools,
      ImageDesign,
      ImageEditorTools
    },
    methods: {
      enableReset: function() {
        this.resetDisabled = false;
      },
      horizontalMove: function(value) {
        this.left += value;
        this.enableReset();
      },
      verticalMove: function(value) {
        this.top += value;
        this.enableReset();
      },
      handleScale: function(value){
        var image = document.getElementById('image');
        // Visual update
        image.style.height = (this.base + (this.base * value / 10)) + 'px';
        image.style.width = ((this.base * this.aspect) + ((this.base * this.aspect) * value / 10)) + 'px';

        // Calculated stored value update
        this.imageHeight = this.base + (this.base * value / 10);
        this.imageWidth = (this.base * this.aspect) + ((this.base * this.aspect) * value / 10);
        this.enableReset();
      },
      writeCanvas: function(image, canvas) {
        var ratio = this.ratio;
        var scale = (this.imageHeight / this.base);
        var ctx = canvas.getContext('2d');
        var sx = (ratio / scale) * (((this.imageWidth - this.canvasWidth) / 2) - this.leftOffset);
        var sy = (ratio / scale) * (((this.imageHeight - this.canvasHeight) / 2) - this.topOffset);
        ctx.drawImage(image, sx, sy, (this.canvasWidth / scale * ratio), (this.canvasHeight / scale * ratio), 0, 0, canvas.width, canvas.height);
        this.canvas = canvas.toDataURL('image/jpeg');
      },
      toCanvas: function(){
        var $this = this;
        var image = document.getElementById('hidden-canvas');
        var canvas = document.getElementById('image-canvas');
        $this.writeCanvas(image, canvas);
      },
      loadImage: function() {
        var image = document.getElementById('image');
        var canvas = document.getElementById('image-canvas');
        var $this = this;
        image.onload = function() {
          var originalImage = new Image();
          originalImage.src = image.src;

          if (image.offsetHeight >= canvas.offsetHeight) {
            $this.base = canvas.offsetHeight
          } else {
            $this.base = image.offsetHeight
          }

          $this.canvasHeight = canvas.offsetHeight;
          $this.canvasWidth = canvas.offsetWidth;
          $this.imageHeight = image.offsetHeight;
          $this.imageWidth = image.offsetWidth;
          $this.aspect = $this.imageWidth / $this.imageHeight
          $this.ratio = image.offsetHeight / $this.base

          $this.handleScale(0);
          $this.resetDisabled = true;
        }
      },
      initCanvasToImage: function() {
        var canvas = document.getElementById('hidden-canvas');
        var image = document.getElementById('image');
        if (canvas) {
          var displayCanvas = document.getElementById('image-canvas');
          var ratio = canvas.width / canvas.height;

          var newHiddencanvas = document.createElement('canvas');
          newHiddencanvas.style.display = 'none';
          newHiddencanvas.id = 'hidden-canvas';
          newHiddencanvas.width = displayCanvas.height * ratio;
          newHiddencanvas.height = displayCanvas.height;
          var ctx = newHiddencanvas.getContext('2d');
          ctx.drawImage(canvas, 0, 0, canvas.width, canvas.height, 0, 0, newHiddencanvas.width, newHiddencanvas.height);

          window.localStorage.setItem('image', newHiddencanvas.toDataURL('image/jpeg'));
          document.body.appendChild(newHiddencanvas);
          canvas.parentNode.removeChild(canvas);
        }

        this.canvas = window.localStorage.getItem('image');
        image.src = this.canvas;
      },
      widowWidth: function() {
        this.windowWidth = window.innerWidth;
      },
      initMantra: function() {
        var params = '';
        var updateData = '';
        var mantraData = '';
        var mantraid = this.$route.params.mantraId;
        var resource = this.$route.params.resource;
        if (resource === 'text') {
          mantraData = TextMantraData.mantras.filter(x => x.id == mantraid)[0];
        } else if (resource === 'image') {
          mantraData = ImageMantraData.mantras.filter(x => x.id == mantraid)[0];
        }

        // Set resource type
        this.resource = resource;

        updateData = mantraData.presets;
        updateData.message = mantraData.message;
        updateData.hashtag = mantraData.hashtag;
        updateData.icon = mantraData.icon;
        updateData.options = mantraData.options;

        // Check for params passed by screenshot
        if (window.location.search != '') {
          params = window.location.search.split('?')[1];
        } else if (window.location.hash != '' && window.location.hash.includes('?')) {
          params = window.location.hash.split('?')[1];
        } else if (getCookie('mantra')) {
          params = getCookie('mantra').split('?')[1];
        }

        // If params, update the data object
        if (params) {
          params = decodeURIComponent(params).split('&');
          for (var i=0; i<params.length; i++) {
            var key = params[i].split('=')[0];
            var value = params[i].split('=')[1];
            updateData[key] = value;
          }
        }

        this.$store.dispatch('updateStore', updateData);
      },
      resetMantra: function() {
        var $this = this;
        if (this.resource == 'image') {
          this.top = 0;
          this.left = 0;
          if (document.querySelector('.imageScale')) {
            document.querySelector('.imageScale').value = 0
          }
          this.handleScale(0);
        }
        this.resetDisabled = true;

        if (window.location.search != '') {
          window.location.href = window.location.search.split('?')[0];
          $this.$router.go()
        } else if (window.location.hash != '' && window.location.hash.includes('?')) {
          window.location.href = window.location.hash.split('?')[0];
          $this.$router.go()
        } else if (getCookie('mantra')) {
          window.location.href = getCookie('mantra').split('?')[0];
          $this.$router.go()
        }

        this.initMantra();
      },
      screenShot: function() {
        if (this.resource == 'image') {
          this.toCanvas();
        }
        var $this = this;
        var imgStore = this.getStore;

        var reqParams = {
          primarybackground: imgStore['primarybackground'],
          secondarybackground: imgStore['secondarybackground'],
          textareacolor: imgStore['textareacolor'],
          textcolor: imgStore['textcolor'],
          textstyle: imgStore['textstyle'],
          textareaborder: imgStore['textareaborder'],
          locale: imgStore['locale'],
          mantraid: this.$route.params.mantraId,
          resource: this.resource,
          image: this.canvas
        };

        var params = Object.keys(reqParams).map((key) => {
          return encodeURIComponent(key) + '=' + encodeURIComponent(reqParams[key])
        });
        var queryString = params.join('&');
        // Cookie mantra data
        document.cookie = "mantra=" + queryString;
        document.cookie = "resource=" + this.$route.params.resource;
        // Get screenshot, cookie returned URL
        axios.post(process.env.VUE_APP_NOW_ENDPOINT, reqParams).then(response => {
          document.cookie = "staticimage=" + response.data.image;
          document.cookie = "shareurl=" + response.data.long_url;
          $this.$router.push('/share');
        });

        window.dataLayer.push({
          'event': 'nav-click',
          'clickPath': '/share',
          'clickTitle': 'next',
          'locale': getCookie('lang')
        });
      }
    },
    beforeMount: function () {
      this.$store.dispatch('updateShare', false);
      this.$store.dispatch('updateMantrapage', true);
      this.initMantra();
    },
    mounted: function() {
      this.$nextTick(function(){
        this.$emit('loader-inactive');
        this.widowWidth();
        window.addEventListener('resize', this.widowWidth);

        if (window.location.search != '' ||
          window.location.hash != '' && window.location.hash.includes('?') ||
          getCookie('mantra')) {
            this.enableReset();
        }

        if (this.resource == 'image') {
          this.initCanvasToImage();
          this.loadImage();
          window.addEventListener('resize', this.loadImage);
        }
      });
    },
    computed: {
      getStore() {
        return {
          primarybackground: this.$store.state.primarybackground,
          secondarybackground: this.$store.state.secondarybackground,
          textareacolor: this.$store.state.textareacolor,
          textcolor: this.$store.state.textcolor,
          textstyle: this.$store.state.textstyle,
          textareaborder: this.$store.state.textareaborder,
          message: this.$store.state.message,
          hashtag: this.$store.state.hashtag,
          icon: this.$store.state.icon,
          options: this.$store.state.options,
          locale:  this.$store.state.locale
        }
      }
    },
    watch: {
      left: function(value) {
        var multiplier = value * 10;
        var image = document.getElementById('image');
        image.style.left = 'calc(50% + ' + multiplier + 'px';
        this.leftOffset = multiplier;
      },
      top: function(value) {
        var multiplier = value * 10;
        var image = document.getElementById('image');
        image.style.top = 'calc(50% + ' + multiplier + 'px';
        this.topOffset = multiplier;
      }
    },
    destroyed: function() {
      document.removeEventListener('resize', this.loadImage);
      document.removeEventListener('resize', this.widowWidth);
    }
  }
</script>

<style lang="scss">
  .responsivesite #wrapper #uyh-app,
  #uyh-app {
    .uyh-send-a-message {
      min-height: 600px;
      height: 100%;
      .editor-wrapper {
        align-items: stretch;
        display: flex;
        flex-wrap: wrap;
        height: 100%;
      }
    }
    @media screen and (max-width: 767px) {
      .uyh-send-a-message {
        .editor-wrapper {
          flex-direction: column;
          flex-wrap: nowrap;
        }
      }
    }
  }
</style>
